import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SleepIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Sleep",
    children: /*#__PURE__*/_jsx("path", {
      d: "M17 28C9.83 28 4 22.17 4 15 4 9.57 7.4 4.88 12.67 3.05c.52-.18 1.09.1 1.27.62s-.1 1.09-.62 1.27c-4.45 1.54-7.33 5.49-7.33 10.05 0 6.07 4.93 11 11 11 3.91 0 7.37-2.11 9.25-5.52-.62.1-1.23.15-1.91.15-4.08 0-7.9-1.64-10.23-4.39-1.79-2.12-2.54-4.75-2.09-7.41.09-.54.61-.92 1.15-.82.54.09.91.61.82 1.15-.35 2.1.22 4.1 1.65 5.79 1.95 2.31 5.21 3.68 8.71 3.68 1.18 0 2.12-.16 3.34-.58.36-.12.76-.03 1.03.24s.36.67.24 1.03c-1.83 5.27-6.52 8.67-11.95 8.67Z"
    })
  }));
};